import { parseValueFromTransform } from '../../../render/dom/parse-transform.mjs';
import { transformPropOrder } from '../../../render/utils/keys-transform.mjs';
import { number } from '../../../value/types/numbers/index.mjs';
import { px } from '../../../value/types/numbers/units.mjs';

var isNumOrPxType = function isNumOrPxType(v) {
  return v === number || v === px;
};

var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter(function (key) {
  return !transformKeys.has(key);
});

function removeNonTranslationalTransform(visualElement) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function (key) {
    var value = visualElement.getValue(key);

    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}

var positionalValues = {
  // Dimensions
  width: function width(_ref, _ref2) {
    var x = _ref.x;
    var _ref2$paddingLeft = _ref2.paddingLeft,
        paddingLeft = _ref2$paddingLeft === void 0 ? "0" : _ref2$paddingLeft,
        _ref2$paddingRight = _ref2.paddingRight,
        paddingRight = _ref2$paddingRight === void 0 ? "0" : _ref2$paddingRight;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function height(_ref3, _ref4) {
    var y = _ref3.y;
    var _ref4$paddingTop = _ref4.paddingTop,
        paddingTop = _ref4$paddingTop === void 0 ? "0" : _ref4$paddingTop,
        _ref4$paddingBottom = _ref4.paddingBottom,
        paddingBottom = _ref4$paddingBottom === void 0 ? "0" : _ref4$paddingBottom;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function top(_bbox, _ref5) {
    var _top = _ref5.top;
    return parseFloat(_top);
  },
  left: function left(_bbox, _ref6) {
    var _left = _ref6.left;
    return parseFloat(_left);
  },
  bottom: function bottom(_ref7, _ref8) {
    var y = _ref7.y;
    var top = _ref8.top;
    return parseFloat(top) + (y.max - y.min);
  },
  right: function right(_ref9, _ref10) {
    var x = _ref9.x;
    var left = _ref10.left;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: function x(_bbox, _ref11) {
    var transform = _ref11.transform;
    return parseValueFromTransform(transform, "x");
  },
  y: function y(_bbox, _ref12) {
    var transform = _ref12.transform;
    return parseValueFromTransform(transform, "y");
  }
}; // Alias translate longform names

positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
export { isNumOrPxType, positionalValues, removeNonTranslationalTransform };